import { Injectable } from '@angular/core';
import { AuthenticationResult, PublicClientApplication, SilentRequest } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MsalAuthService {
  private accessToken: string | null = null;
  private clientId: string | null = null;
  private currentRoute: string | null = null;
  private tenantId: string | null = null;
  private msalInstance: PublicClientApplication | null = null;
  private authenticationResult: AuthenticationResult | null = null;
  private authCode: string | null = null;
  private codeVerifier: string | null = null;
  private scope: string | null = null;

  setAccessToken(accessToken: string) {
    this.accessToken = accessToken;
  }
  
  getAccessToken(): string | null {
    return this.accessToken;
  }

  setAuthCode(authCode: string) {
    this.authCode = authCode;
  }
  
  getAuthCode(): string | null {
    return this.authCode;
  }

  setClientId(clientId: string) {
    this.clientId = clientId;
  }
  
  getClientId(): string | null {
    return this.clientId;
  }

  setCodeVerifier(codeVerifier: string) {
    this.codeVerifier = codeVerifier;
  }
  
  getCodeVerifier(): string | null {
    return this.codeVerifier;
  }

  setCurrentRoute(route: string) {
    this.currentRoute = route;
  }

  getCurrentRoute(): string {
    return this.currentRoute;
  }

  setScope(scope: string) {
    this.scope = scope;
  }

  getScope(): string | null {
    return this.scope;
  }

  setTenantId(tenantId: string) {
    this.tenantId = tenantId;
  }

  getTenantId(): string | null {
    return this.tenantId;
  }

  setMsalInstance(msalInstance: PublicClientApplication) {
    this.msalInstance = msalInstance;
  }

  getMsalInstance(): PublicClientApplication | null {
    return this.msalInstance;
  }

  setAuthenticationResult(result: AuthenticationResult) {
    this.authenticationResult = result;
  }

  getAuthenticationResult(): AuthenticationResult | null {
    return this.authenticationResult;
  }

  async initializeSession(clientId: string, tenantId: string): Promise<void> {
    this.msalInstance = new PublicClientApplication({
      auth: {
        clientId: clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: `${environment.siteUrl}/azure-auth-callback`
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
      },
    });
    
    try {
      const accounts = this.msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        const silentRequest: SilentRequest = {
          scopes: ['openid', 'profile', 'https://graph.microsoft.com/Sites.Read.All'],
          account: accounts[0]
        };
        this.authenticationResult = await this.msalInstance.acquireTokenSilent(silentRequest);
      }
    } catch (error) {
      console.error("Erro ao recuperar a sessão do MSAL:", error);
    }
  }
}